import { Directive, OnChanges, ElementRef, Input, OnInit } from '@angular/core';
export class CountToDirective implements OnChanges, OnInit {
  
  CountTo: number;
  
  from = 0;
  
  duration = 4;

  e = this.el.nativeElement;
  num: number;
  refreshInterval = 30;
  steps: number;
  step = 0;
  increment: number;
/**
 * @param {?} el
 */
constructor(private el: ElementRef) {

  }
/**
 * @return {?}
 */
ngOnInit() {

  }
/**
 * @return {?}
 */
ngOnChanges() {
    if (this.CountTo) {
      this.start();
    }
  }
/**
 * @return {?}
 */
calculate() {
    this.duration = this.duration * 1000;

    this.steps = Math.ceil(this.duration / this.refreshInterval);
    this.increment = ((this.CountTo - this.from) / this.steps);
    this.num = this.from;
  }
/**
 * @return {?}
 */
tick() {
    setTimeout(() => {
      this.num += this.increment;
      this.step++;
      if (this.step >= this.steps) {
        this.num = this.CountTo;
        this.e.textContent = this.CountTo;
      } else {
        this.e.textContent = Math.round(this.num);
        this.tick();
      }
    }, this.refreshInterval);
  }
/**
 * @return {?}
 */
start() {
    this.calculate();
    this.tick();
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[CountTo]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'CountTo': [{ type: Input },],
'from': [{ type: Input },],
'duration': [{ type: Input },],
};
}

function CountToDirective_tsickle_Closure_declarations() {
/** @type {?} */
CountToDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CountToDirective.ctorParameters;
/** @type {?} */
CountToDirective.propDecorators;
/** @type {?} */
CountToDirective.prototype.CountTo;
/** @type {?} */
CountToDirective.prototype.from;
/** @type {?} */
CountToDirective.prototype.duration;
/** @type {?} */
CountToDirective.prototype.e;
/** @type {?} */
CountToDirective.prototype.num;
/** @type {?} */
CountToDirective.prototype.refreshInterval;
/** @type {?} */
CountToDirective.prototype.steps;
/** @type {?} */
CountToDirective.prototype.step;
/** @type {?} */
CountToDirective.prototype.increment;
/** @type {?} */
CountToDirective.prototype.el;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
